import { useEffect, useState } from 'react'
import Modal from '../../components/Modal'
import Button from '../../components/Button'
import { HelpTip } from '../../components/HelpTip'
import { useToast } from '../../components/Toast.jsx'
import { reverseDepreciation } from '../../api/operatingCosts'
import { money } from '../sales/salesShared'
import { monthName } from './accountingShared'

// Reverse the last month of depreciation posted on an asset, with a new
// opposite entry; the original stays in the books.
export default function ReverseDepreciationModal({ open, asset, lastRun, onClose, onReversed }) {
  const { notify } = useToast()
  const [reason, setReason] = useState('')
  const [error, setError] = useState('')
  const [saving, setSaving] = useState(false)

  useEffect(() => { if (open) { setReason(''); setError('') } }, [open])
  if (!open || !asset) return null

  const reverse = async () => {
    if (!reason.trim()) { setError('Say why it’s being reversed.'); return }
    setSaving(true)
    setError('')
    try {
      const res = await reverseDepreciation(asset.asset_id, { reason: reason.trim() })
      notify(`Reversed ${monthName(res.period_ym)}`)
      onReversed?.()
      onClose?.()
    } catch (e) {
      setError(e.message || 'Could not reverse the depreciation.')
    } finally {
      setSaving(false)
    }
  }

  const ym = lastRun?.period_ym || asset.last_posted_ym
  return (
    <Modal
      open={open}
      onClose={() => { if (!saving) onClose?.() }}
      title={<>Reverse {monthName(ym)} <HelpTip k="reverseDepreciation" /></>}
      subtitle={lastRun ? `${money(lastRun.amount)} of depreciation on ${asset.name}.` : `The last month posted on ${asset.name}.`}
      preventClose={saving}
      footer={(
        <>
          <Button variant="ghost" onClick={() => onClose?.()} disabled={saving}>Cancel</Button>
          <Button variant="danger" onClick={reverse} loading={saving}>Reverse</Button>
        </>
      )}
    >
      {error && <p className="acc-modal-error">{error}</p>}
      <label className="ci-form-field">
        <span>Why?</span>
        <input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="e.g. Posted to the wrong asset" />
      </label>
    </Modal>
  )
}
